module.exports = __webpack_public_path__ + "static/blob-6a97cb99485c43c67935e40000dd6c89.png";